import { processFormItems } from "./processFormItems";
import { processItemsMultiUom, processItemsMultiOther } from "./processItemsMultiSeries";

export function processItems({transaction, settings, productList, isRestoreAutosaveForm = false }) {
    let nonBaseUomItems, removedBundles;
    let hasTaxChange, hasLocationChange;
    let finalFormItems;

    // Form Items
    if (transaction.form_items) {
        // Handle UOM, Tax, Location
        const {
            // processedFormItems,
            finalFormItems: finalFormItemsFunc,
            nonBaseUomItems: nonBaseUomItemsFunc,
            hasTaxChange: hasTaxChangeFunc,
            hasLocationChange: hasLocationChangeFunc,
            removedBundles: removedBundlesFunc,
        } = processFormItems({
            formItems: transaction.form_items || [],
            productList,
            settings,
            // set initType to 'restoreAutosave' so that all data, eg transfer_transaction details, will be preserved
            initType: isRestoreAutosaveForm ? 'restoreAutosave' : undefined,
        });

        finalFormItems = finalFormItemsFunc;
        hasTaxChange = hasTaxChangeFunc;
        hasLocationChange = hasLocationChangeFunc;
        nonBaseUomItems = nonBaseUomItemsFunc;
        removedBundles = removedBundlesFunc;
    }

    // Stock Adjustment and Stock Transfer
    else if (transaction.items) {
        const {
            newItems: postUOMFormItems,
            nonBaseUomItems: nonBaseUomItemsFunc,
        } = processItemsMultiUom({ items: transaction.items, productList });

        const {
            newItems: finalFormItemsFunc,
            hasLocationChange: hasLocationChangeFunc,
        } = processItemsMultiOther({ items: postUOMFormItems, settings });

        finalFormItems = finalFormItemsFunc;
        hasLocationChange = hasLocationChangeFunc;
        nonBaseUomItems = nonBaseUomItemsFunc;
    }

    // Bank Income and Expense
    else if (transaction.bank_items) {
        const {
            newItems: finalFormItemsFunc,
            hasTaxChange: hasTaxChangeFunc,
        } = processItemsMultiOther({ items: transaction.bank_items, settings });

        finalFormItems = finalFormItemsFunc;
        hasTaxChange = hasTaxChangeFunc;
    }

    const hasItemsChange =
    nonBaseUomItems?.length || removedBundles?.length || hasLocationChange || hasTaxChange;

    return {
        finalFormItems,
        hasTaxChange,
        hasLocationChange,
        nonBaseUomItems,
        removedBundles,
        hasItemsChange,
    };
}
